import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './WhyTrustUs.css';
import { TargetIcon, LightningIcon, RocketIcon, CheckIcon } from './icons/ServiceIcons';

const WhyTrustUs = () => {
  const { t } = useLanguage();
  
  const reasons = [
    t('whyTrustUs.stats.projects'),
    t('whyTrustUs.stats.experience'),
    t('whyTrustUs.stats.team'),
    t('whyTrustUs.stats.support'),
    t('whyTrustUs.stats.agile')
  ];

  return (
    <section className="why-trust-us section">
      <div className="container">
        <div className="why-trust-content">
          <div className="why-trust-text">
            <h2 className="section-title">{t('whyTrustUs.title')}</h2>
            <p className="why-trust-description">
              {t('whyTrustUs.subtitle')}
            </p>
            <ul className="reasons-list">
              {reasons.map((reason, index) => (
                <li key={index} className="reason-item">
                  <span className="reason-icon"><CheckIcon size={20} /></span>
                  {reason}
                </li>
              ))}
            </ul>
          </div>
          <div className="why-trust-visual">
            <div className="trust-graphic">
              <div className="trust-circle trust-circle-1">
                <TargetIcon size={32} />
              </div>
              <div className="trust-circle trust-circle-2">
                <LightningIcon size={32} />
              </div>
              <div className="trust-circle trust-circle-3">
                <RocketIcon size={32} />
              </div>
              <div className="connecting-lines">
                <div className="line line-1"></div>
                <div className="line line-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;